import { writable, derived, get } from "svelte/store";
import cart from "./cart";
import { settings } from "./settings";
function createForm() {
    const formStore = writable({});
    function increment(id) {
        const formState = get(formStore);
        formStore.update((state) => (Object.assign(Object.assign({}, state), { [id]: ((formState === null || formState === void 0 ? void 0 : formState[id]) || 0) + 1 })));
    }
    function decrement(id) {
        const formState = get(formStore);
        formStore.update((state) => (Object.assign(Object.assign({}, state), { [id]: Math.max(0, ((formState === null || formState === void 0 ? void 0 : formState[id]) || 0) - 1) })));
    }
    return Object.assign(Object.assign({}, formStore), { increment,
        decrement });
}
const form = createForm();
export default form;
export const isFormLoading = writable(false);
export const formCount = derived(form, ($form) => Object.values($form).reduce((acc, val) => {
    acc += val;
    return acc;
}, 0));
export async function addFormToCart() {
    const formStore = get(form);
    isFormLoading.set(true);
    const res = await fetch(`/wp-json/farmcomp-store/cart`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(formStore),
    });
    if (res === null || res === void 0 ? void 0 : res.ok) {
        await cart.fetch();
        const { cartUrl } = get(settings);
        window.location.href = cartUrl;
    }
    else {
        console.error(res);
    }
    isFormLoading.set(false);
}
